import { useCallback } from 'react'

import { FormDialog } from "components/dialog/form"
import { ConfirmDialog } from 'components/dialog/confirm'

import { TargetListFileForm, useTargetListFileForm } from "../form/targetListFileForm"
import { TargetListForm, useTargetListForm } from "../form/targetListForm"

import {
  AddTargetListResult, TargetListResult,
  usePostTargetListComplex
} from "interface/search/targetList"

type EntryTargetListDialogProps = {
  searchId: number
  onSubmit: (
    targetList: TargetListResult,
    result: AddTargetListResult | null
  ) => void
  onClose: () => void
}
export const EntryTargetListDialog = ({
  searchId,
  onSubmit,
  onClose
}: EntryTargetListDialogProps) => {
  const onPosted = useCallback(
    (targetList: TargetListResult, result: AddTargetListResult) => {
      onSubmit(targetList, result)
    },
    [onSubmit]
  )
  const { posting, percent, error, post } = usePostTargetListComplex(searchId, { onPosted })

  const form = useTargetListForm()
  const fileForm = useTargetListFileForm()
  const { confirm, setConfirm } = fileForm

  return (
    <>
      <FormDialog
        open
        fullWidth
        maxWidth='sm'
        title="ターゲットリスト登録"
        isLoading={fileForm.loading || posting}
        percent={percent}
        error={error}
        body={
          <>
            <TargetListForm {...form}/>
            <TargetListFileForm {...fileForm} onChoiceFileTitle={form.setFileTitle}/>
          </>
        }
        submitLabel="実 行"
        isValid={
          form.formState.isValid &&
          !form.formState.isSubmitting &&
          !fileForm.isDisabled
        }
        onSubmit={form.handleSubmit(data => {
          fileForm.submit(
            fileFormData => post({
              listName: data.listName,
              description: data.description ?? ''
            }, fileFormData)
          )
        })}
        onClose={onClose}
      />
      {confirm ? (
        <ConfirmDialog
          message={confirm.title}
          onOk={() => {
            setConfirm(null)
            confirm?.onOk()
          }}
          onCancel={() => setConfirm(null)}
        />
      ) : <></> }
    </>
  )
}
